import { render, staticRenderFns } from "./ProcessExcellenceHeader.vue?vue&type=template&id=23a16ab9&scoped=true&"
import script from "./ProcessExcellenceHeader.vue?vue&type=script&lang=js&"
export * from "./ProcessExcellenceHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProcessExcellenceHeader.vue?vue&type=style&index=0&id=23a16ab9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a16ab9",
  null
  
)

export default component.exports